// @flow

import { combineEpics } from 'redux-observable';

import { commonEpics } from './commonEpics';
import { contentEpics } from './contentEpics';
import { depositEpics } from './depositEpics';
import { franceConnectEpics } from './franceConnectEpics';
import { i18nEpics } from './i18nEpics';
import { landingEpics } from './landingEpics';
import { paypalConnectEpics } from './paypalConnectEpics';
import { sessionEpics } from './sessionEpics';
import { tagManagerEpics } from './tagManagerEpics';
import { userRegistrationEpics } from './userRegistrationEpics';
import { websocketEpics } from './websocketEpics';

export const rootEpic = combineEpics(
  websocketEpics,
  contentEpics,
  i18nEpics,
  commonEpics,
  userRegistrationEpics,
  depositEpics,
  franceConnectEpics,
  sessionEpics,
  landingEpics,
  tagManagerEpics,
  paypalConnectEpics,
);
